import React, { useState } from "react";
import {DefaultButton, Dialog, DialogFooter, PrimaryButton, TooltipHost} from '@fluentui/react';
import DeletePowerAppDialogContent from "./DeletePowerAppDialogContent";

const DeletePowerAppBtn = ({powerApp, updateApp}) => {

    const [showDialog, setShowDialog] = useState(false)

    const onConfirmDialog = () => {
        updateApp(null, null, null, true);
        setShowDialog(false)
    }

    const onCancelDialog = () => {
        setShowDialog(false)
    }

    const confirmationDialog = 
        <Dialog 
            hidden={!showDialog}
            maxWidth={600}
            dialogContentProps={{
                title: `Confirm "${powerApp.name}" deletion`,
            }}
            modalProps={{
                isBlocking: false
            }}
        >
            <DeletePowerAppDialogContent powerApp={powerApp} />
            <DialogFooter>
                <PrimaryButton onClick={onConfirmDialog} text="Yes, delete" />
                <DefaultButton onClick={onCancelDialog} text="No, cancel" />
            </DialogFooter>
        </Dialog>

    const icofrBlockMsg = 
        <div>
            <div><b>Deletion not allowed</b></div>
            <div>You cannot delete this element be-cause it is within an ICOR environ-ment, which follows a different deletion procedure.</div>
            <div>Please refer to the <a href="https://abb.sharepoint.com/:w:/t/ICoFRonPowerPlatform/EUYIXjvjlWtNnSamf4EfFXQBQWR-SM-UKt9uk3VFhTRDdA?e=ZLWYgV">ICOR guidelines</a> or contact the environment owner for further steps.</div>
        </div>

    return (
        <div style={{float: 'right', marginRight: '-12px'}}>
            <TooltipHost content={powerApp.environment.isIcofr ? icofrBlockMsg : ''}>
                <DefaultButton
                    text='Delete'
                    className="edit-icon"
                    onClick={() => setShowDialog(true)}
                    disabled={powerApp.environment.isIcofr}
                />
            </TooltipHost>
            {confirmationDialog}
        </div>
    )
}

export default DeletePowerAppBtn;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/DeletePowerAppBtn.js